import * as React from "react";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import { Grid, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";


export default function ModalPaymentReceipt(props: any) {
    let accumulative = false;
    // if (props.fileData.isAccumulative == true && props.fileData.accumulativeAmount == props.fileData.inquiryAmount) {
    //     accumulative = true;
    // }

    const [open, setOpen] = React.useState(props.openModal);
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        props.setOpenModal(false);
    };
    const maxWidth: DialogProps["maxWidth"] = "lg";
    React.useEffect(() => {
        setOpen(props.openModal);
    }, [props.openModal])
    return (
        <div className="dialogCheque">
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        width: "40%",
                        maxWidth: "none",
                        maxHeight: "100%",
                        overflowY: "unset",
                        padding: "10px 20px 20px 10px",
                    },
                }}
            >
                <>
                    <IconButton onClick={handleClose}>
                        <CloseIcon
                            style={{
                                position: "absolute",
                                zIndex: "1",
                                left: "0",
                                color: "red",
                                marginLeft: "5px",
                                marginTop: "3vh",
                            }}
                        />
                    </IconButton>
                    <Grid
                        item xs={12}
                        className="classCenter"
                        style={{ padding: '3vh' }}
                    >

                        <span
                            className="colorDefaultFont fontWeight textFont12 mbottom10"
                            style={{
                                marginTop: '-20px', marginRight: '20px', background: props.color ? "transparent" : "#fff", paddingRight: '10px',
                                paddingLeft: '10px', display: 'flex',
                                alignItems: ' center',
                                width: 'fit-content',
                                transform: 'translateY(25%)',
                            }}
                        >
                            اطلاعات پرداخت
                        </span>
                        <Box
                            sx={{
                                p: 3,
                                border: "1px solid #DAE0E4",
                                borderRadius: '5px',
                                marginTop: '-14px',
                            }}
                            className="visible-print "
                        >
                            <Grid xs={12} style={{ backgroundColor: "#E6FBEA", borderRadius: '5px' }}>
                                <p className="SuccessDefaultFont fontSize" style={{ fontSize: "15px", paddingTop: '1.5vh', paddingBottom: '1.5vh' }}>تراکنش موفق</p>
                            </Grid>
                            <Grid container xs={12} >
                                <Grid item xs={6} className="subColor textFont14 alignRight">
                                    <span>نام درگاه:</span>
                                </Grid>
                                <Grid item xs={6} className="fontBlueColor alignLeft textFont14">
                                    <span>{props.fileData ? props?.fileData.installments[0]?.gatewayName : ""}</span>
                                </Grid>
                            </Grid>
                            <hr />
                            <Grid container xs={12} >
                                <Grid item xs={6} className="subColor textFont14 alignRight">
                                    <span>نام طرح تسهیلات:</span>
                                </Grid>
                                <Grid item xs={6} className="fontBlueColor alignLeft textFont12">
                                    <span>{props?.fileData ? props?.fileData.installments[0]?.loanTemplateTitle : ""}</span>
                                </Grid>
                            </Grid>
                            <hr />
                            <Grid container xs={12} >
                                <Grid item xs={6} className="subColor textFont14 alignRight">
                                    <span>تاریخ سررسید:</span>
                                </Grid>
                                <Grid item xs={6} className="fontBlueColor alignLeft textFont14">
                                    <span>{props?.fileData ? props?.fileData.installments[0]?.dueDate_Persian : ""}</span>
                                </Grid>
                            </Grid>
                            <hr />
                            <Grid container xs={12} >
                                <Grid item xs={6} className="subColor textFont14 alignRight">
                                    <span>تعداد روزهای شامل جریمه: </span>
                                </Grid>
                                <Grid item xs={6} className="fontBlueColor alignLeft textFont14">
                                    <span>{props?.fileData ?
                                        props?.fileData.installments[0]?.penaltyDays > 0 ? props?.fileData.installments[0]?.penaltyDays + " روز" : "--" : ""}
                                    </span>
                                </Grid>
                            </Grid>
                            <hr />
                            <Grid container xs={12} >
                                <Grid item xs={6} className="subColor textFont14 alignRight">
                                    <span>تاریخ و زمان پرداخت:</span>
                                </Grid>
                                <Grid item xs={6} className="fontBlueColor alignLeft textFont14" style={{ direction: "ltr" }}>
                                    <span>
                                        {props?.fileData ? props?.fileData.installments[0]?.paymentDatePersian.split(" ")[0] + " - " + props?.fileData.installments[0]?.paymentDatePersian.split(" ")[1] : ""}
                                    </span>
                                </Grid>
                            </Grid>
                            <hr />
                            <Grid container xs={12} >
                                <Grid item xs={6} className="subColor textFont14 alignRight">
                                    <span>شناسه مرجع:</span>
                                </Grid>
                                <Grid item xs={6} className="fontBlueColor alignLeft textFont14">
                                    <span>{props?.fileData ? props?.fileData.installments[0].transactionCode : ""}</span>
                                </Grid>
                            </Grid>
                            <hr />
                            <Grid container xs={12} >
                                <Grid item xs={6} className="subColor textFont14 alignRight">
                                    <span>مبلغ قسط: </span>
                                </Grid>
                                <Grid item xs={6} className="fontBlueColor alignLeft textFont14">
                                    <span>{props?.fileData ? props?.fileData.installments[0].amount.toLocaleString() + " ریال" : ""}</span>
                                </Grid>
                            </Grid>
                            <hr />
                            <Grid container xs={12} className={`${props?.fileData ? props?.fileData.installments[0].penaltyAmount ?
                                "DangerDisableOpacity  " : "" : ""}`}>
                                <Grid item xs={6} className={`${props?.fileData ? props?.fileData.installments[0].penaltyAmount ?
                                    " colorRed textFont14 alignRight" : "subColor textFont14 alignRight" : "subColor textFont14 alignRight"}`}>
                                    <span>جریمه دیرکرد:</span>
                                </Grid>
                                <Grid item xs={6} className={`${props?.fileData ? props?.fileData.installments[0].penaltyAmount ?
                                    " colorRed alignLeft textFont14" : "fontBlueColor  alignLeft textFont14" : "fontBlueColor alignLeft textFont14"}`}>
                                    <span>{props?.fileData ?
                                        props?.fileData.installments[0].penaltyAmount > 0 ?
                                            props?.fileData.installments[0].penaltyAmount.toLocaleString() + " ریال" : "--" : ""}
                                    </span>
                                </Grid>
                            </Grid>
                            <hr />
                            <Grid container xs={12} style={{ borderBottom: "1px solid #fff", marginBottom: '-1.5vh' }}>
                                <Grid item xs={6} className="subColor textFont14 alignRight">
                                    <span>مجموع مبلغ پرداخت:</span>
                                </Grid>
                                <Grid item xs={6} className="fontBlueColor alignLeft textFont14">
                                    <span>{props?.fileData ? props?.fileData.installments[0].totalPaidAmount.toLocaleString() + " ریال" : ""}</span>
                                </Grid>
                            </Grid>

                        </Box>


                    </Grid>

                </>
            </Dialog>
        </div >
    );
}
